
export class ControllerEvent {

  readonly eventName: string;
  readonly eventData: any;
  readonly eventTarget: string;

  constructor(eventName: string,
              eventData: any,
              eventTarget: string = '') {
    this.eventName = eventName;
    this.eventData = eventData;
    this.eventTarget = eventTarget;
  }
}
